<form [formGroup]="form">
  <div class="col-xs-12 col-sm-11 col-md-11 form-group">
    <label>BUYER CONFIG</label>
    <ps-ui-select-dropdown
      class="select_box_nc"
      [dropdownItems]="ncBuyerConfigs"
      [field]="'name'"
      [enableSearch]="true"
      labelNone="Choose Buyer Config"
      [label]="form.value.buyer?.name"
      (selectedItem)="setBuyerCofig($event)"
    >
    </ps-ui-select-dropdown>
  </div>
  <div class="col-xs-12 col-sm-11 col-md-11 form-group">
    <label>BUYER NAME</label>
    <input
      type="text"
      name="buyerName"
      class="form-control survey-style width100"
      formControlName="buyerName"
    />
  </div>
  <div class="col-xs-12 col-sm-11 col-md-11 form-group">
    <label>SECURITY TYPE</label>
    <ps-ui-select-dropdown
      class="select_box_nc"
      [dropdownItems]="NC_SECURITY_OPTIONS"
      [field]="'label'"
      [enableSearch]="true"
      labelNone="Choose Security Type"
      [label]="form.value.security.label"
      (selectedItem)="form.controls.security.patchValue($event)"
    >
    </ps-ui-select-dropdown>
  </div>
  <div
    class="col-xs-12 col-sm-11 col-md-11 form-group"
    *ngIf="form.value.security?.value === 1 || form.value.security?.value === 2"
  >
    <label>LINK SECURITY KEY</label>
    <input
      type="text"
      name=""
      class="form-control survey-style"
      formControlName="securityKey"
    />
  </div>
  <div class="col-xs-12 col-sm-11 col-md-11 form-group buyer_config_btn mt-0">
    <a href="javascript:void(0);" (click)="reset()" class="pull-right"
      >CANCEL</a
    >
  </div>
  <div class="col-xs-12 col-sm-11 col-md-11 form-group">
    <label>BUYER ENTRY LINK</label>
    <input
      type="text"
      name=""
      class="form-control survey-style width100"
      formControlName="buyerEntryLink"
    />
  </div>
  <div class="col-xs-12 col-sm-11 col-md-11 form-group">
    <button
      type="button"
      class="btn btn-default submit-btn btn-lg btn-block sync_redirect_btn"
      (click)="syncSurveyToNightcrawler()"
    >
      SYNC TO REDIRECT SYSTEM
    </button>
  </div>
</form>
